<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">掲載候補商品リスト</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">注文商品区分</label>
              <div class="list-input-content">
                <app-code-combo-box id="cmb_OrderGoodsFlg" #cmb_OrderGoodsFlg [subid]="'cmb_OrderGoodsFlg'"
                  [codeDiv]="'ctp110'" [blank]="false" [forcedEnabledMode]="'true'" [tabindex]="0"
                  [disabled]="kymw1404Model.disabledOrderGoodsFlg" (change)="eventOrderGoodsFlg_CHANGEHandler()"
                  (keydown)="tabkey_focusEventHandler($event)">
                </app-code-combo-box>
              </div>
              <label class="list-input-title">売り場</label>
              <div class="list-input-content">
                <select id="cmb_SellAreaName" #cmb_SellAreaName forcedEnabledMode="true" [tabindex]="0"
                  [(ngModel)]="kymw1404Model.sellingArea" [disabled]="kymw1404Model.disabledSellAreaName"
                  (change)="eventSellAreaName_CHANGEHandler()" (keydown)="tabkey_focusEventHandler($event)">
                  <ng-template ngFor let-item [ngForOf]="kymw1404Model.sellingAreaArray">
                    <option value="{{item}}">{{item}}</option>
                  </ng-template>
                </select>
              </div>
              <label class="list-input-title">注文コード割当</label>
              <div class="list-input-content">
                <app-order-num-quota-code-combo-box id="cmb_OrderNumQuota" #cmb_OrderNumQuota [width]="225"
                  [subid]="'cmb_OrderNumQuota'" [blank]="true" [tabindex]="0" [forcedEnabledMode]="'true'"
                  [labelField]="'OrderNumQuotaCodeName'" [orderCode]="kymw1404Model.orderCodeOrderNumQuota"
                  [mediumType]="kymw1404Model.mediumTypeOrderNumQuota" [disabled]="kymw1404Model.disabledOrderNumQuota"
                  (change)="eventOrderNumQuota_CHANGEHandler()" (keydown)="tabkey_focusEventHandler($event)">
                </app-order-num-quota-code-combo-box>
              </div>
              <button id="btn_Search" #btn_Search class="btn-secondary" (click)="eventSearch_CLICKHandler()"
                forcedEnabledMode="true" (keydown)="tabkey_focusEventHandler($event)" [tabindex]="0">掲載候補商品検索</button>
            </div>
            <div class="column-list" style="height: max-content;">
              <label class="list-input-title">掲載商品</label>
              <div class="list-input-content">
                <app-checkbox-label [label]="'Ｗ掲載予定商品のみ'" id="chb_WPublishFlg" #chb_WPublishFlg
                  [subid]="'chb_WPublishFlg'" [forcedEnabledMode]="'true'" [tabindex]="0"
                  [(ngModel)]="kymw1404Model.chkWPublish" [disabled]="kymw1404Model.disabledWPublishFlg"
                  (change)="eventWPublishFlg_CLICKHandler()" (keydown)="tabkey_focusEventHandler($event)">
                </app-checkbox-label>
                <app-checkbox-label [label]="'未掲載商品のみ'" id="chb_NotPublishFlg" #chb_NotPublishFlg
                  [subid]="'chb_NotPublishFlg'" [forcedEnabledMode]="'true'" [tabindex]="0"
                  [(ngModel)]="kymw1404Model.chkNotPublish" (change)="eventNotPublishFlg_CHANGEHandler()"
                  (keydown)="tabkey_focusEventHandler($event)">
                </app-checkbox-label>
              </div>
              <label class="list-input-title">部門</label>
              <div class="list-input-content">
                <app-class-code-combo-box id="cmb_ClassCode" #cmb_ClassCode [subid]="'cmb_ClassCode'" [blank]="true"
                  [orderCode]="" [tabindex]="0" [forcedEnabledMode]="'true'" (change)="eventClassCode_CHANGEHandler()"
                  (keydown)="tabkey_focusEventHandler($event)">
                </app-class-code-combo-box>
              </div>
            </div>
          </div>
        
          <div class="grid-container">
            <div class="action-area">
              <div class="guide-label">
                <label class="pink-bgcolor">掲載済商品</label>
                <label class="organge-bgcolor">他媒体の選定商品</label>
                <label class="green-bgcolor">未掲載のW掲載予定商品</label>
                <label class="yellow-bgcolor">Ｗ掲載親コマ配置商品</label>
              </div>
            </div>
            <!-- データグリッド定義 -->
            <wj-flex-grid id="dtg_NominationGoodsList" #dtg_NominationGoodsList
              [itemsSource]="kymw1404Model.nominationGoodsArray" [isReadOnly]="true" allowDragging="Rows"
              [deferResizing]="true" [headersVisibility]="'Column'" [selectionMode]="'ListBox'" [frozenColumns]="4"
              [allowSorting]="false" forcedEnabledMode="true" [tabindex]="-1">
              <wj-flex-grid-filter #flr_NominationGoodsList></wj-flex-grid-filter>
              <wj-flex-grid-column [minWidth]="5" [width]="80" [header]="'配置'" [binding]="'Arranged'"
                [align]="'center'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="65" [header]="'Ｗ'" [binding]="'WPublish'"
                [align]="'center'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="65" [header]="'差'" [binding]="'OrderCodeDiff'"
                [align]="'center'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="290" [header]="'商品名'"
                [binding]="'GuideGoodsName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="140" [header]="'規格名'" [binding]="'GuideStandardName'">
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'Ｐコード'"
                [binding]="'Pcode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="140" [header]="'部門'"
                [binding]="'ClassName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="140" [header]="'中分類'"
                [binding]="'MiddleClassName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="140" [header]="'小分類'"
                [binding]="'SmallClassName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="95" [header]="'温度帯'"
                [binding]="'GuideTempZoneName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="165" [header]="'プロモーションマーク'"
                [binding]="'MarkCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="130" [header]="'価格パターン'"
                [binding]="'PricePattern'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="110" [header]="'供給価格'" [binding]="'ThisTimeSupplyPrice'"
                [align]="'right'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="145" [header]="'バイヤーコメント'"
                [binding]="'BuyerComment'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="115" [header]="'計画数'" [binding]="'PlanNum'"
                [align]="'right'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="135" [header]="'計画額(千円)'" [binding]="'PlanPrice'"
                [align]="'right'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="115" [header]="'ＧＰＲ'" [binding]="'Gpr'" [align]="'right'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{ cell.item.Gpr === '' ? '' : cell.item.Gpr.toFixed(1) }}
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="115" [header]="'紐付コード'"
                [binding]="'RelateMasterCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" [header]="'い'" [binding]="'EnableIbaraki'"
                [align]="'center'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" [header]="'と'" [binding]="'EnableTochigi'"
                [align]="'center'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" [header]="'ぐ'" [binding]="'EnableGunma'"
                [align]="'center'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" [header]="'ち'" [binding]="'EnableChiba'"
                [align]="'center'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" [header]="'さ'" [binding]="'EnableSaitama'"
                [align]="'center'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" [header]="'とう'" [binding]="'EnableTokyo'"
                [align]="'center'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" [header]="'な'" [binding]="'EnableNagano'"
                [align]="'center'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="70" [header]="'に'" [binding]="'EnableNiigata'"
                [align]="'center'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="110" [header]="'注文コード'"
                [binding]="'OrderNum'"></wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      </div>
      <div class="window-title-close">
        <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
        <button id="closebtn" #closebtn [tabindex]="0" (click)="eventBtnEndCLICKHandler()"
          (keydown)="tabkey_focusEventHandler($event)" forcedEnabledMode="true"></button>
      </div>
      <div cdkDragHandle class="drag-subwindow-bottom-area"></div>
    </td>
  </tr>
</table>